import {
  Routes,
  Route,
  useLocation,
} from "react-router-dom";

// import components
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import Home from "../Home/Home";
import KitchenEquipments from "../KitchenEquipments/KitchenEquipments";
import { useEffect } from "react";

const App = () => {
  const location = useLocation();
  const pathname = location.pathname;
  useEffect(() => {
    const headElemet = document.getElementById("app-header-id");
    const headElemetHeight = headElemet && headElemet.offsetHeight;
    const bannerElement = document.getElementById("app-home-id");
    const kitchenEquipmentsElement =
      document.getElementById("kitchen-equipments");
    bannerElement &&
      bannerElement.setAttribute("style", `margin-top:${headElemetHeight}px`);
    kitchenEquipmentsElement &&
      kitchenEquipmentsElement.setAttribute(
        "style",
        `margin-top:${headElemetHeight}px`
      );
    window.scrollTo({ top: 0 });
  }, [pathname]);
  return (
    <div>
      <div>
        <Header />
      </div>
      <div>
        <Routes>
          <Route path="/" element={<Home />}></Route>
          <Route
            path="/kitchen-equipments"
            element={<KitchenEquipments />}
          ></Route>
        </Routes>
      </div>
      <div>
        <Footer />
      </div>
    </div>
  );
};

export default App;
